/*@flow*/
import type { Element } from 'react';
import React, { useState, useEffect, createRef } from 'react';
import useAutocomplete from 'lib/useAutocomplete';
import * as I from 'immutable';

type PropsT = {
  onChange: (string, $Shape<Goog$PlaceT>) => any,
  name: string,
  address: string,
};

export default (props: PropsT): Element<'input'> => {
  const { address, onChange, name } = props;
  const [formattedAddress, setFormattedAddress] = useState(address || '');
  const [isPristine, setPristine] = useState(true);
  const ref = createRef();
  const { googPlace } = useAutocomplete(ref);

  useEffect(() => {
    if (!googPlace) return;
    const re = /, (USA|Canada)$/;
    const v = I.getIn(googPlace, ['formatted_address'], '').replace(re, '');
    setFormattedAddress(v);
  }, [googPlace]);

  useEffect(() => {
    if (!address || !isPristine) return;
    setFormattedAddress(address);
    setPristine(false);
  }, [address]);

  useEffect(() => {
    if (!formattedAddress || formattedAddress === props.address) return;
    onChange(formattedAddress, googPlace);
  }, [formattedAddress]);

  return (
    <input
      placeholder="Enter an address"
      ref={ref}
      value={formattedAddress || ''}
      onChange={(el) => {
        if (!el) return;
        const value = el.target.value;
        setFormattedAddress(value);
      }}
      name={name}
      className="form-control"
    />
  );
};
